<template>
  <v-tooltip bottom color="#181818" small>
    <template v-slot:activator="{ on, attrs }">
      <v-icon class="help" size="24" v-bind="attrs" v-on="on" @click="openModal"
        >mdi-help-circle-outline</v-icon
      >
    </template>

    <span>{{ $t("helpers.chat.you_need_help") }}</span>
  </v-tooltip>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "HelpComponent",

  methods: {
    ...mapActions(["changeHelpModalStatus"]),

    openModal() {
      this.changeHelpModalStatus(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  &:hover {
    color: #1876d2;
  }
}
</style>
